// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae972acc","239":"f48cec37","453":"ad889744","455":"c21ef17c"}[chunkId] + ".chunk.js";
};